"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLibraryComponents = parseLibraryComponents;
exports.parseLibraryXml = parseLibraryXml;
const xml_js_1 = require("xml-js");
const board_1 = require("./board");
const schematic_1 = require("./schematic");
const schematic_2 = require("./schematic");
const Common_1 = require("./Types/Common");
const ObjMap_1 = require("./ObjMap");
const Utils_1 = require("@cadstrom/sigma-engine-shared/dist/Utils");
function parseLibraryComponents(libraryContents, libName) {
    const xmlRoot = parseLibraryXml(libraryContents);
    const libXml = xmlRoot.eagle.drawing.library;
    const libDeviceSets = (0, Common_1.toArray)(libXml).map((l) => [
        l,
        (0, Common_1.toArray)(l.devicesets?.deviceset),
    ]);
    const warnings = [];
    const components = new Map();
    for (const [lib, deviceSets] of libDeviceSets) {
        for (const deviceSet of deviceSets) {
            for (const device of (0, Common_1.toArray)(deviceSet.devices.device)) {
                const cpName = (0, schematic_1.getComponentName)({ library: lib._attributes?.name || libName }, deviceSet, device);
                let component = components.get(cpName);
                const symbols = (0, ObjMap_1.toMap)((0, Common_1.toArray)(deviceSet.gates.gate).map((g) => (0, schematic_1.getSymbol)(lib, g._attributes.symbol)), (s) => s._attributes.name);
                const gateMap = (0, ObjMap_1.toMap)((0, Common_1.toArray)(deviceSet.gates.gate), (g) => g._attributes.name, (g) => g._attributes.symbol);
                if (!component) {
                    const symbols = (0, ObjMap_1.toMap)((0, Common_1.toArray)(deviceSet.gates.gate).map((g) => (0, schematic_1.getSymbol)(lib, g._attributes.symbol)), (s) => s._attributes.name);
                    component = (0, schematic_1.parseComponentDefinition)(cpName, lib, device, deviceSet, symbols, undefined);
                    if (!component) {
                        warnings.push(`Could not parse component definition for ${cpName}`);
                        continue;
                    }
                    components.set(cpName, component);
                    (0, schematic_2.parseComponentSignals)(component, deviceSet, symbols, gateMap, device, undefined, warnings);
                }
                const devicePackage = (0, Common_1.toArray)(lib.packages.package).find((p) => p._attributes.name === device._attributes.package);
                if (!devicePackage) {
                    warnings.push(`Could not find device package (${device._attributes.package})`);
                    continue;
                }
                const footprint = (0, board_1.readFootprint)(devicePackage, device._attributes.name, lib._attributes?.name || libName, undefined);
                component.footprints.push(footprint);
                component.numPads = footprint.pads.length;
                if (component) {
                    component.numPads = (0, Utils_1.maxA)(...component.footprints.map((f) => f.pads.length));
                }
            }
        }
    }
    return {
        components: Array.from(components.values()),
        warnings,
    };
}
function parseLibraryXml(lib) {
    const json = (0, xml_js_1.xml2json)(lib, { compact: true });
    return JSON.parse(json);
}
//# sourceMappingURL=library.js.map